import { ComponentType } from 'react';
import { useLocation } from 'react-router-dom';

// React Router v6+ no longer auto-injects route props (location, history, match) into
// components rendered via <Route element={...} />. This HOC restores that behaviour for
// class components by reading location from the useLocation hook and passing it as a prop.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withRouter(WrappedComponent: ComponentType<any>) {
  function WithRouterWrapper(props: Record<string, unknown>) {
    const location = useLocation();
    return <WrappedComponent {...props} location={location} />;
  }
  WithRouterWrapper.displayName = `WithRouter(${WrappedComponent.displayName ?? WrappedComponent.name})`;
  return WithRouterWrapper;
}
